module.exports = __webpack_public_path__ + "static/persona2-d2f6e7e5bf4925a216c5ef66e7f1f478.png";